import en_GB from './en_GB.json';

const messages = {
  'en-GB': en_GB,
};

export default messages;
